import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { TurnosComponent } from './turnos/turnos.component';
import { CargaComponent } from './carga/carga.component';
import { ZonasComponent } from './carga/zonas/zonas.component';
import { BarriosComponent } from './carga/barrios/barrios.component';
import { OsComponent } from './carga/os/os.component';
import { CentrosComponent } from './carga/centros/centros.component';
import { ProfesionalesComponent } from './carga/profesionales/profesionales.component';
import { EditarProfesionalComponent } from './carga/profesionales/editar-profesional/editar-profesional.component';

const routes: Routes = [
  {
    path: '', redirectTo: '/inicio', pathMatch: 'full'
  },
  {path: 'inicio', component: HomeComponent },
  {path: 'turnos', component: TurnosComponent },
  {path: 'carga', component: CargaComponent},
  {path: 'carga/zonas', component: ZonasComponent },
  {path: 'carga/barrios', component: BarriosComponent },
  {path: 'carga/os', component: OsComponent },
  {path: 'carga/centros', component: CentrosComponent },
  {path: 'carga/profesionales', component: ProfesionalesComponent },
  {path: 'carga/profesionales/:id', component: EditarProfesionalComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/app-routing.module.ts